import React from 'react';
import { Product, Props as ProductProps } from './Product';
import PRO_ZD801 from 'assets/products/PRO-ZD801.png';
import SGV_2020 from 'assets/products/SGV-2020.png';
import EFB_PCTH from 'assets/products/EFB-PCTH.png';
import IRC_150 from 'assets/products/IRC-150.png';
import HTW_110 from 'assets/products/HTW-110.png';
import { Container } from './Container';

const products: ProductProps[] = [
  {
    src: PRO_ZD801,
    title: '自然養生機',
    code: 'PRO-ZD801',
    features: [
      '真空破壁，冷熱全能',
      '8段速度調控，能輕鬆應付各種烹調需要',
      '安全耐溫Tritan™容杯不含BPA',
      '日本高碳鋼攪拌刀，攪拌效果突出',
      '摩打7年保用',
    ],
    specs: [
      '尺寸：(H) 456 (W) 222 (D) 220 mm',
      '包裝尺寸：(H) 427 (W) 338 (D) 248 mm',
      '淨重：4.1 kg',
    ],
  },
  {
    src: SGV_2020,
    title: '迷你多功能蒸烤焗爐',
    code: 'SGV-2020',
    videoId: 'lJ2dzFqRDPM',
    features: [
      '6大預設功能：蒸、烤、焗、慢煮、氣炸',
      '30℃-230℃控溫範圍，2000W超強火力',
      '內置多達23款預設食譜，一按即煮',
      '輕觸式控制面板，操作簡單易用',
      '900毫升易拆儲水箱，可連續蒸煮達1小時',
      '超迷你機身，20公升特大容量',
    ],
    specs: [
      '尺寸：(H) 345 (W) 362 (D) 440 mm',
      '爐腔尺寸(約)：(H) 237 (W) 290 (D) 238 mm',
      '淨重：11.3 kg',
    ],
  },
  {
    src: EFB_PCTH,
    title: '空氣淨化風扇暖風機',
    code: 'EFB-PCTH',
    videoId: 'MmFy2syml08',
    features: [
      '波長254納米UVC殺菌系統',
      'UVC高效殺滅99.9%常見細菌，確保出風乾淨無菌',
      'HEPA 13高效濾網過濾99.9%空氣中的污染物',
      '全方位捕捉PM2.5懸浮微粒',
      '空氣淨化、涼暖風三合一',
      'PTC陶瓷極速製暖，風力柔和不乾燥',
    ],
    specs: [
      '尺寸：(H) 700 (W) 255 (D) 255 mm',
      '包裝尺寸：(H) 780 (W) 315 (D) 290 mm',
      '淨重：4.65 kg',
    ],
  },
  {
    src: IRC_150,
    title: 'IH多功能電飯煲',
    code: 'IRC-150',
    videoId: 'fLJmWVBVqDI',
    features: [
      '3D立體IH電磁技術，米飯均勻受熱',
      '8大烹調功能：精煮、焦飯、煲湯、清蒸等',
      '自動化智能操控，一鍵輕鬆煮出完美米飯',
      '24小時超長智能預約功能',
      '3公升特大內鍋容量，足夠全家分享',
    ],
    specs: [
      '尺寸：(H) 230 (W) 248 (D) 302 mm',
      '包裝尺寸：(H) 295 (W) 360 (D) 598 mm',
      '淨重：4.8 kg',
    ],
  },
  {
    src: HTW_110,
    title: '移動浴室寶',
    codeDisplay: 'HTW-111PN (粉紅色) / HTW-111BL(藍色)',
    code: 'HTW-111',
    videoId: '1ZwGjpafyOs',
    features: [
      '掛牆、座枱兩用，易裝易拆，隨心移動',
      '兩檔暖風模式及涼風功能，365日四季皆宜',
      '可拆式鋁架，晾掛及烘乾毛巾或小衣物',
      'PTC陶瓷極速製暖，風力柔和不乾燥',
      '升級版活動式出風口，調校最佳送風角度',
    ],
    specs: [
      '尺寸(包含毛巾架)：(H) 380 (W) 306 (D) 150 mm',
      '尺寸(不包含毛巾架)：(H) 262 (W) 262 (D) 150 mm',
      '包裝尺寸：(H) 338 (W) 308 (D) 198 mm',
      '淨重：2.84kg',
    ],
  },
];

export const ProductList = React.memo(() => {
  return (
    <Container>
      {products.map((_, index) => (
        <Product
          {..._}
          key={index}
          reverse={index % 2 === 1}
          last={index === products.length - 1}
          first={index === 0}
        />
      ))}
    </Container>
  );
});
